/* unplugin-vue-components disabled */import { render } from "./Bucket.vue?vue&type=template&id=7b417357&scoped=true"
import script from "./Bucket.vue?vue&type=script&lang=js"
export * from "./Bucket.vue?vue&type=script&lang=js"

import "./Bucket.vue?vue&type=style&index=0&id=7b417357&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b417357"]])

export default __exports__